<app-box-1
  [padding]="32"
  [borderWidth]="2"
  [borderRadius]="32"
  [backgroundColor]="'#00000060'"
  [backdropFilterBlur]="24"
>
  <section class="info-and-chat">
    <app-box-1
      [padding]="16"
      [borderWidth]="1"
      [borderRadius]="16"
      [backgroundColor]="'#00000040'"
      [backdropFilterBlur]="24"
    >
      <div class="info-and-chat__container">
        <app-info-route class="info-and-chat__info" />
        
        @if (chatId()) {
          <app-chatbot 
            class="info-and-chat__chatbot"
            [chatID]="chatId()"
          />
        }
      </div>
    </app-box-1>
  </section>
</app-box-1>